<template>
  <div class="zone">
    <v-lazy-img :data-url="image.url" />
    <template v-for="item in zone">
      <a
        :class="{ 'is-preview': isPreview }"
        v-if="item.url_object && item.url_object.url"
        :key="item.id"
        :href="item.url_object.url"
        :style="{
          width: computed_size(item.percentage_width),
          height: computed_size(item.percentage_height),
          top: computed_size(item.percentage_y),
          left: computed_size(item.percentage_x),
        }"
      ></a>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    zone: {
      default: {},
      require: true,
    },
    image: {
      require: true,
    },
  },
  data() {
    return {
      isPreview: false,
    };
  },
  methods: {
    computed_size(val) {
      let value = 0;
      if (!isNaN(val - 0)) {
        value = val * 100 + "%";
      }
      return value;
    },
  },
  mounted() {
    this.isPreview = window.location.search.includes("preview");
  },
};
</script>
<style scoped lang='scss'>
.zone {
  position: relative;
  img {
    display: block;
    width: 100%;
  }
  a {
    display: inline-block;
    position: absolute;
  }
  .is-preview {
    background-color: #ea00ff;
    opacity: 0.4;
  }
}
</style>